// extracted by mini-css-extract-plugin
export var actions = "_2v-0";
export var actionsContainer = "_2v-7";
export var border = "_2v-1";
export var childFullHeight = "_2v-f";
export var collapse = "_2v-2";
export var content = "_2v-a";
export var contentChild = "_2v-e";
export var fullscreen = "_2v-c";
export var hasLeftRadius = "_2v-k";
export var headerContainer = "_2v-3";
export var headerRow = "_2v-5";
export var hidePadding = "_2v-b";
export var navCollapsedGap = "_2v-l";
export var noScrollX = "_2v-m";
export var noScrollY = "_2v-n";
export var noTopPadding = "_2v-i";
export var optOutTopPadding = "_2v-d";
export var pageMain = "_2v-j";
export var pageOuter = "_2v-g";
export var pagePadding = "_2v-8";
export var pageScroll = "_2v-9";
export var profile = "_2v-o";
export var profileContainer = "_2v-p";
export var profileImage = "_2v-q";
export var profileMain = "_2v-r";
export var profileSubtitle = "_2v-t";
export var profileTitle = "_2v-s";
export var showLeftPadding = "_2v-h";
export var tabsPortalSlot = "_2v-6";
export var tabsWrapper = "_2v-4";
export var title = "_2v-u";